module.exports = __webpack_public_path__ + "img/3.c65470f1.svg";